import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
export function MidPageCTA() {
  const checkoutUrl = 'https://ewordmedia.com/cart/48415277515004:1?checkout';
  return <section className="w-full bg-emerald-50 py-14 md:py-20" data-id="element-580">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-581">
        <h2 className="text-2xl md:text-3xl font-bold text-stone-900 mb-2" data-id="element-582">
          Start Using Natural Remedies Today
        </h2>
        <p className="text-lg text-stone-700 mb-6" data-id="element-583">
          Get The Complete Natural Healing Bundle
        </p>
        <p className="text-2xl font-bold text-emerald-700 mb-6" data-id="element-584">
          Only $17 Today
        </p>
        <a href={checkoutUrl} data-cta="mid-page" onClick={() => {
        if (typeof window !== 'undefined' && (window as any).fbq) {
          ;
          (window as any).fbq('track', 'AddToCart');
        }
      }} className="inline-block bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 focus:from-orange-600 focus:to-orange-700 focus:outline-none focus:ring-4 focus:ring-orange-300 text-white px-10 py-5 rounded-2xl text-lg font-bold transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-[1.02] focus:shadow-xl focus:scale-[1.02] transform mb-5" data-id="element-585">
          <span className="flex items-center justify-center gap-2" data-id="element-586">
            <span data-id="element-587">Get Instant Access</span>
            <ChevronRightIcon className="w-5 h-5" data-id="element-588" />
          </span>
        </a>
        <div className="flex items-center justify-center gap-2 text-sm text-stone-500 flex-wrap" data-id="element-589">
          <span data-id="element-590">Instant digital access</span>
          <span className="text-stone-400" data-id="element-591">•</span>
          <span data-id="element-592">Secure checkout</span>
          <span className="text-stone-400" data-id="element-593">•</span>
          <span data-id="element-594">30-day money-back guarantee</span>
        </div>
      </div>
    </section>;
}